import { render, staticRenderFns } from "./AdminSales.vue?vue&type=template&id=0c891896&scoped=true"
import script from "./AdminSales.vue?vue&type=script&lang=js"
export * from "./AdminSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c891896",
  null
  
)

export default component.exports